import { 
	Typography,
	StepLabel,
	StepButton,
	Step,
	Stepper,
	Toolbar,
	Paper,
	Button 
} from '@material-ui/core';
import React, { Fragment, useEffect } from 'react';
import ReduxFormSelect from 'shared/components/ReduxFormSelect';
import removeHTML from 'shared/utils/removeHTML';
import { Field, FieldArray } from 'redux-form';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { BrowserView, MobileView } from 'react-device-detect';
import theme from 'shared/themes/storis';
import CoAppCurrentEmploymentFields from './CoAppCurrentEmploymentFields';
import CoAppCurrentResidenceFields from './CoAppCurrentResidenceFields';
import CoAppPersonalInformationFields from './CoAppPersonalInformationFields';
import CurrentEmploymentFields from './CurrentEmploymentFields';
import CurrentResidenceFields from './CurrentResidenceFields';
import PersonalInformationFields from './PersonalInformationFields';
import PersonalReferenceFields from './PersonalReferenceFields';
import PreviousEmploymentFields from './PreviousEmploymentFields';
import PreviousResidenceFields from './PreviousResidenceFields';
import SectionDivider from './SectionDivider';
import {
	APP_TYPE_CUSTOMER_JOINT,
	APP_TYPE_OPTIONS,
	COAPP_CURRENT_EMPLOYMENT_STATUS_FIELDS,
	COAPP_CURRENT_RESIDENCE_STATUS_FIELDS,
	COAPP_SETTING,
	CURRENT_EMPLOYMENT,
	CURRENT_EMPLOYMENT_STATUS_FIELDS,
	CURRENT_RESIDENCE_STATUS_FIELDS,
	PERSONAL_REFERENCES,
	PERSONAL_REFERENCE_STATUS_FIELDS,
	PREVIOUS_EMPLOYMENT_STATUS_FIELDS,
	PREVIOUS_RESIDENCE_STATUS_FIELDS,
	PRIMARY_SETTING,
} from './constants';
import withRouter from 'shared/utils/WithRouter';

export const styles = {
	button: {
		'@media only screen and (max-width: 320px) and (orientation: portrait)': {
			width: '50px',
		},
		'@media only screen and (min-width: 321px) and (max-width: 420px) and (orientation: portrait)': {
			width: '105px',
		},
	},
	panelDiv: {
		width: '100%',
		maxWidth: '800px',
		margin: 'auto',
	},
	paper: {
		width: '95%',
		maxWidth: '800px',
		height: 'auto',
		margin: 'auto',
	},
	paperDiv: {
		marginBottom: '15px',
		padding: '25px',
	},
	stepper: {
		backgroundColor: '#FFFFFF',
		width: '95%',
		height: 'auto',
		maxWidth: '800px',
		marginTop: '8px',
		marginLeft: 'auto',
		marginRight: 'auto',
	},
	topButtons: {
		display: 'flex',
		justifyContent: 'flex-end',
		flexShrink: '0',
	},
	buttonToolbar: {
		flexFlow: 'row wrap',
		justifyContent: 'space-between',
		position: 'sticky',
		top: '0',
		backgroundColor: '#FFFFFF',
		marginBottom: '8px',
		zIndex: '2',
		fallbacks: {
			position: '-webkit-sticky',
		},
	},
	mobileStepIndicator: {
		marginLeft: '16px',
		marginTop: '-8px',
		color: theme.palette.primary.main,
		display: 'inline-block',
		position: 'absolute',
		left: '0',
	},
	headerLogo: {
		height: '100%',
		textAlign: 'center',
	},
	logoImg: {
		objectFit: 'contain',
		height: '100%',
		width: '100%',
	},
};

const renderReferences = ({ fields, settings }) =>
	fields.map((member, index) => (
		// eslint-disable-next-line react/no-array-index-key
		<div key={index}>
			<SectionDivider title={`Personal Reference ${index + 1}`} />
			<PersonalReferenceFields settings={settings} member={member} index={index} />
		</div>
	));

const sectionNeeded = (properties, primaryOrCoApp, settings) => {
	const foundOne = properties.some(
		element =>
			settings[primaryOrCoApp][element].fieldStatus === 'O' ||
			settings[primaryOrCoApp][element].fieldStatus === 'M',
	);
	return foundOne;
};

function ApplicationEntry(props) {
	const {
		classes,
		formValues,
		openCancelConfirmModal,
		settings,
		valid,
		applicantIndicator,
	} = props;

	useEffect(() => {
		if (settings === undefined) {
			props.router.navigate('/now');
		}
		window.scrollTo(0, 0);
	}, []);

	// Don't display unless settings have loaded
	if (!settings || !settings.primary) {
		return null;
	}

	return (
		<form autoComplete="off">
			<MobileView>
				<div className={classes.buttonToolbar}>
					<Toolbar className={classes.topButtons}>
						<div className={classes.headerLogo}>
							<img alt="logo" id="header-logo-image" className={classes.logoImg} />
						</div>
					</Toolbar>
				</div>
			</MobileView>
			<div className={classes.buttonToolbar}>
				<Toolbar className={classes.topButtons}>
					<MobileView>
						<Typography
							type="body1"
							component="div"
							className={classes.mobileStepIndicator}
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: removeHTML('Step 1 of 4'),
							}}
						/>
					</MobileView>
					<Field
						className={classes.button}
						name="applicantIndicator"
						component={ReduxFormSelect}
						menuOptions={APP_TYPE_OPTIONS}
						style={{ display: 'none' }}
					/>
					<BrowserView>
						<div className={classes.headerLogo}>
							<img alt="logo" id="header-logo-image" className={classes.logoImg} />
						</div>
					</BrowserView>
					<Button onClick={openCancelConfirmModal}>Cancel</Button>
					{props.router.location.state && props.router.location.state.update === true ? (
						<Button
							variant="contained"
							disabled={!valid}
							color="primary"
							onClick={() => props.router.navigate('/ApplicationReview')}
						>
							Update
						</Button>
					) : (
						<Button
							variant="contained"
							disabled={!valid}
							color="primary"
							onClick={() => props.router.navigate('/ApplicationReview')}
						>
							Continue
						</Button>
					)}
				</Toolbar>
			</div>
			<div className={classes.stepperToolbar}>
				<BrowserView>
					<Stepper className={classes.stepper} activeStep={0} alternativeLabel>
						<Step key={1}>
							<StepLabel>Personal Information</StepLabel>
						</Step>
						<Step key={2}>
							<StepButton onClick={() => props.router.navigate('/ApplicationReview')}>
								<StepLabel>Review</StepLabel>
							</StepButton>
						</Step>
						<Step key={3}>
							<StepButton>
								<StepLabel>Agreement</StepLabel>
							</StepButton>
						</Step>
						<Step key={4}>
							<StepButton>
								<StepLabel>Status</StepLabel>
							</StepButton>
						</Step>
					</Stepper>
				</BrowserView>
			</div>
			<div className={classes.panelDiv}>
				<Paper elevation={6} className={classes.paper}>
					<div className={classes.paperDiv}>
						{/* Personal Information */}
						<SectionDivider hideDivider title="Personal Information" />
						<PersonalInformationFields settings={settings} />
						{/* Current Residence */}
						{sectionNeeded(CURRENT_RESIDENCE_STATUS_FIELDS, PRIMARY_SETTING, settings) ? (
							<Fragment>
								<SectionDivider title="Current Residence" />
								<CurrentResidenceFields settings={settings} />
							</Fragment>
						) : null}
						{/* Previous Residence */}
						{sectionNeeded(PREVIOUS_RESIDENCE_STATUS_FIELDS, PRIMARY_SETTING, settings) ? (
							<Fragment>
								<SectionDivider title="Previous Residence" />
								<PreviousResidenceFields settings={settings} />
							</Fragment>
						) : null}
						{/* Current Employment */}
						{sectionNeeded(CURRENT_EMPLOYMENT_STATUS_FIELDS, PRIMARY_SETTING, settings) ? (
							<Fragment>
								<SectionDivider sectionId={CURRENT_EMPLOYMENT} title="Current Employment" />
								<CurrentEmploymentFields settings={settings} formValues={formValues} />
							</Fragment>
						) : null}
						{/* Previous Employment */}
						{sectionNeeded(PREVIOUS_EMPLOYMENT_STATUS_FIELDS, PRIMARY_SETTING, settings) ? (
							<Fragment>
								<SectionDivider title="Previous Employment" />
								<PreviousEmploymentFields settings={settings} />
							</Fragment>
						) : null}
						{/* Personal References */}
						{sectionNeeded(PERSONAL_REFERENCE_STATUS_FIELDS, PRIMARY_SETTING, settings) ? (
							<FieldArray
								name={PERSONAL_REFERENCES}
								component={renderReferences}
								settings={settings}
							/>
						) : null}
					</div>
				</Paper>
			</div>
			{applicantIndicator === APP_TYPE_CUSTOMER_JOINT ? (
				<div className={classes.panelDiv}>
					<Paper elevation={6} className={classes.paper}>
						<div className={classes.paperDiv}>
							<SectionDivider hideDivider title="Co-Applicant: Personal Information" />
							<CoAppPersonalInformationFields settings={settings} />
							{sectionNeeded(COAPP_CURRENT_RESIDENCE_STATUS_FIELDS, COAPP_SETTING, settings) ? (
								<Fragment>
									<SectionDivider title="Co-Applicant: Current Residence" />
									<CoAppCurrentResidenceFields settings={settings} />
								</Fragment>
							) : null}
							{sectionNeeded(COAPP_CURRENT_EMPLOYMENT_STATUS_FIELDS, COAPP_SETTING, settings) ? (
								<Fragment>
									<SectionDivider title="Co-Applicant: Current Employment" />
									<CoAppCurrentEmploymentFields settings={settings} />
								</Fragment>
							) : null}
						</div>
					</Paper>
				</div>
			) : null}
		</form>
	);
}

ApplicationEntry.propTypes = {
	classes: PropTypes.shape({
		flexContainer: PropTypes.string,
		leftItem: PropTypes.string,
	}).isRequired,
	formValues: PropTypes.shape({}),
	openCancelConfirmModal: PropTypes.func.isRequired,
	applicantIndicator: PropTypes.string.isRequired,
	settings: PropTypes.shape({
		primary: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
		coApp: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
		comboFields: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.arrayOf(
					PropTypes.shape({ displayText: PropTypes.string, value: PropTypes.string }),
				),
				PropTypes.number,
			]),
		),
		comboFieldsByValue: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.objectOf(
					PropTypes.shape({
						displayOrder: PropTypes.number,
						fieldName: PropTypes.string,
						displayText: PropTypes.string,
						returnValue: PropTypes.string,
						requiresEmploymentData: PropTypes.bool,
					}),
				),
				PropTypes.number,
			]),
		),
	}),
	valid: PropTypes.bool.isRequired,
};

ApplicationEntry.defaultProps = {
	settings: undefined,
	formValues: {},
};

export default withRouter(withStyles(styles, { name: 'ApplicationEntry' })(ApplicationEntry));

export { renderReferences }; // for testing purposes only
